import { render, staticRenderFns } from "./Scholarships.vue?vue&type=template&id=00e80b26&"
import script from "./Scholarships.vue?vue&type=script&lang=js&"
export * from "./Scholarships.vue?vue&type=script&lang=js&"
import style0 from "./Scholarships.vue?vue&type=style&index=0&id=00e80b26&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports